
(function(template){
    define('vue!app/views/vue/components/packageDivComponent/packageSelectionComponent/serviceItemHeader',['Vue','vuex','vue!basicComponents/serviceCounter','vue!basicComponents/checkBox','vue!basicComponents/packageIndicatorPill', 'helpers'],function(Vue,vuex,serviceCounter,checkBox,packageIndicatorPill, helpers){
        return {
            template:template,
            props:['service','package_item','active','selected','white_pill','no_functionality','bottom_margin','recipientName'],
            components: {
                'service-counter' : serviceCounter,
                'check-box' : checkBox,
                'package-indicator-pill' : packageIndicatorPill
            },
            methods: {
                handleClick: function(service){
                    if(app.customization.googleAnalytics){
                        helpers.analyticsInit('serviceHeaderClick', [service])
                    }
                }
            },
            computed: {
                packageItemsCount: function(){
                    return this.package_item.PackageItems.PackageItem.length;
                },
                serviceName: function(){
                    return this.service.nameWoDuration || this.service.ItemName || this.service.serviceName;
                },
                amount: function(){
                    return this.customization.showPriceIncludingSurcharges ? this.currencyPrefix + this.service.PriceWithSurcharges : this.currencyPrefix + (this.service.Price || this.service.price)
                },
                selectedServices: function(){
                    return this.$store.state.selectedServices;
                },
                getMainUser: function(){
                    return _.keys(this.$store.state.users)[0];
                },
            }
        }
    })
})('<div v-if="service" :click="handleClick(service)" class="serviceItem" :class="{ active: active, \'bottom-margin\':bottom_margin, \'no-pointer\':no_functionality }" tabindex="-1"> <!-- <span> --> <check-box v-if="!singleBookingMode" :selected="selectedServices[service.SpaItemId]" :users="users" :service="true"></check-box> <div class="serviceHeading"> {{ serviceName }} <package-indicator-pill :package_item="package_item" :white_pill="white_pill" ></package-indicator-pill> </div> <!-- </span> --> <span v-if="service.nameWoDuration" class="serviceMins"> {{localStrings.stepper.body.pick.service.multiDurationItemText}} </span> <span v-else class="serviceMins"> <span v-if="customization.showItemPrice">{{amount}} &nbsp;</span> <span v-if="!!package_item"> {{packageItemsCount}} {{localStrings.packageNameLabel}} </span> <span v-else> {{ (customization.showItemPrice ? \'- \' : \'\') + service.ServiceTime }}{{localStrings.stepper.body.pick.service.headerDuarationUnit}}</span> <service-counter v-show="!singleBookingMode" v-if="selected" :count="selectedServices[service.SpaItemId].length" :user="getMainUser" :itemid="service.SpaItemId"></service-counter> </span> </div>');
